import React from 'react';
import { GiftIcon } from 'lucide-react';
import { LEGAL_DISCLAIMER } from '../../data/program';
import { formatOfferAmount } from '../../utils/format';
interface VolunteerDiscountCardProps {
  amount: number;
  message: string;
  size?: 'mobile' | 'desktop';
}
export function VolunteerDiscountCard({
  amount,
  message,
  size = 'mobile'
}: VolunteerDiscountCardProps) {
  const desktop = size === 'desktop';
  return <section aria-label="Volunteer Registration Discount offer" className={`rounded-lg border border-i9-greenLine bg-i9-green font-i9 ${desktop ? 'px-6 py-5' : 'p-4'}`} data-id="element-345" data-mp="2abgih2j4v1d6">
      <div className="flex items-start gap-3" data-id="element-346" data-mp="218xhknywqytk">
        <span className={`flex shrink-0 items-center justify-center rounded-md bg-i9-greenIcon text-white ${desktop ? 'h-11 w-11' : 'h-9 w-9'}`} aria-hidden="true" data-id="element-347" data-mp="21bteqa2xljgy">
          <GiftIcon className={desktop ? 'h-6 w-6' : 'h-5 w-5'} data-id="element-348" data-mp="3vlnk1u3cdgck" />
        </span>
        <div className="min-w-0" data-id="element-349" data-mp="3qp6ju1ivbbj4">
          <h2 className={`font-bold leading-snug text-i9-ink ${desktop ? 'text-[19px]' : 'text-[16.5px]'}`} data-id="element-350" data-mp="2gfiu4b9c23p2">
            Volunteer Coaches can receive a {formatOfferAmount(amount)} registration credit
          </h2>
          <p className={`mt-0.5 text-i9-greenSoft ${desktop ? 'text-[15px]' : 'text-[14px]'}`} data-id="element-351" data-mp="26hl7fs74geyk">Automatically applied to your cart.</p>
        </div>
      </div>
      {message.trim() && <p className={`mt-3 italic leading-relaxed text-i9-greenInk ${desktop ? 'text-[15px]' : 'text-[14px]'}`} data-id="element-352" data-mp="2z60iy4r1of55">{message}</p>}
      <hr className="my-3 border-i9-greenLine/60" data-id="element-353" data-mp="345d9azh4k4ch" />
      <p className={`leading-relaxed text-i9-greenSoft ${desktop ? 'text-[13px]' : 'text-[12.5px]'}`} data-id="element-354" data-mp="346wnmkj805bm">{LEGAL_DISCLAIMER}</p>
    </section>;
}